import { render, staticRenderFns } from "./DatasetsFilters.vue?vue&type=template&id=16f2d113&scoped=true"
import script from "./DatasetsFilters.vue?vue&type=script&lang=js"
export * from "./DatasetsFilters.vue?vue&type=script&lang=js"
import style0 from "./DatasetsFilters.vue?vue&type=style&index=0&id=16f2d113&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f2d113",
  null
  
)

export default component.exports